import React, { Component } from 'react';

import moment from 'moment';

import GuestRouter from './Routers/Guest';
import EmailNotVerifiedRouter from './Routers/emailNotVerified';
import LoggedRouter from './Routers/Logged';

import { withFirebase } from '../components/Firebase';

import ProfileUtil from '../services/ProfileUtil';

import Server from '../services/Server';

import { _AVATAR_ } from '../config/defaults';

import '../css/azia.css';
import '../css/Main.css';
import '../css/Login.css';
import '../css/Profile.css';

import '../css/Events.css';

import '../css/variables.css';
import '../css/viewer-zone.css';
import swal from 'sweetalert';

class MyRouter extends Component {
	constructor(props) {
		super(props);
		this.state = {
			center_loading: true,
			top_loading: false,
			authenticated: false,
			hasMenu: true,
			helpers: {},
		};

		this.onLogout = this.onLogout.bind(this);
		this.onRequestLoading = this.onRequestLoading.bind(this);
		this.setMenuStatus = this.setMenuStatus.bind(this);
		this.setUserParams = this.setUserParams.bind(this);
	}
	componentWillMount() {
		const self = this;
		this.props.firebase.auth.onAuthStateChanged(async (user) => {
			if (user) {
				let rememberChecked = localStorage.getItem('remember');
				rememberChecked = rememberChecked === 'true' ? true : false;

				if (!rememberChecked) {
					/*const { metadata = {} } = user,
						{ lastSignInTime = new Date() } = metadata;

					if (moment().diff(lastSignInTime, 'minutes') >= 5) {
						this.onLogout();
						return 1;
					}*/
				}

				let data = {
					uid: user.uid,
					email: user.email,
					emailVerified: user.emailVerified,
					photoURL: user.photoURL,
					displayName: user.displayName,
					name: { first: '', last: '' },
				};
				data.isAnonymous = user.isAnonymous;

				if (user.isAnonymous) {
					swal('Error', 'Usuario inválido', 'error').then(() => {
						self.onLogout();
					});
					/*
					const doSleep = (ms) => {
						return new Promise((resolve) => setTimeout(resolve, ms));
					};
					await doSleep(400);

					this.setState({
						authenticated: false,
						currentUser: null,
						center_loading: false,
					});

					this.props.firebase.setUser(null);
					*/
				} else {
					const docRef = self.props.firebase.getDoc('users', user.uid);

					docRef
						.get()
						.then(function (doc) {
							if (doc.exists) {
								const _doc = doc.data();
								for (var key in _doc) data[key] = _doc[key];

								self.props.firebase
									.getDoc('helpers', 'paths')
									.onSnapshot((response) => {
										if (response.exists) {
											self.setState({ helpers: response.data() });
										}
									});
							} else {
								const arrName = user.displayName.split(' '),
									_userName = {
										first: arrName[0] || '',
										last: arrName[1] || '',
									};

								docRef.set({
									CREATION_DATE: moment().format('YYYY-MM-DDTHH:mm:SSZ'),
									_CREATION_DATE: moment().unix(),
									name: _userName,
								});
							}

							if (user.displayName === null) {
								const _doc = doc.data(),
									displayName = `${_doc.name.first} ${_doc.name.last}`,
									//photoURL = "https://visualpharm.com/assets/996/Edit%20User%20Male-595b40b65ba036ed117d10dd.svg";
									photoURL = _AVATAR_;

								user
									.updateProfile({
										displayName: displayName,
										photoURL: photoURL,
									})
									.then(function () {
										self.setUserParams({
											displayName: displayName,
											photoURL: photoURL,
										});

										user
											.sendEmailVerification()
											.then(function () {
												console.log('// Email sent.');
											})
											.catch(function (error) {
												console.error('// An error happened.', error);
											});
									})
									.catch((err) => {
										console.error(err);
									});
							}
							const objProfile = new ProfileUtil(data);
							if (typeof data.package_id !== 'undefined') {
								self.props.firebase
									.getDoc('packages', data.package_id)
									.get()
									.then((doc) => {
										if (doc.exists) {
											objProfile.setPackageData(doc.data());
											self.setState({ currentUser: objProfile });
										}
									});
							}

							self.props.firebase.setUser(objProfile);
							self.setState({
								authenticated: true,
								currentUser: objProfile,
								center_loading: false,
							});
						})
						.catch(function (error) {
							self.onLogout();
							console.log(172, 'Error getting document:', error);
						});
				}
			} else {
				this.setState({
					authenticated: false,
					currentUser: null,
					center_loading: false,
				});
				this.props.firebase.setUser(null);
			}
		});
	}
	componentDidMount() {
		/*
        
        this.props.firebase.db.collection('events')
            .where("privacity", "==", "PRIVATE")
            .where("_endDate", ">=", moment().unix())
            .get(); 
        */

		const self = this;

		window.addEventListener(
			'resize',
			function () {
				if (self.state.hasMenu) {
					if (window.innerWidth < 992) {
						self.setState({ hasMenu: false });
					}
				} else {
					if (window.innerWidth >= 992) {
						self.setState({ hasMenu: true });
					}
				}
			},
			true
		);
		if (window.innerWidth < 992 && this.state.hasMenu) {
			self.setState({ hasMenu: false });
		}
	}
	onLogout() {
		this.props.firebase.doSignOut().then(
			function () {},
			function (error) {
				console.log(error);
			}
		);
	}
	onRequestLoading(newStatus) {
		if (newStatus === undefined) {
			newStatus = !this.state.top_loading;
		}

		this.setState({
			top_loading: newStatus,
		});
	}
	setUserParams(params, anotherStates) {
		this.state.currentUser.update(params);
		anotherStates = anotherStates || {};
		this.setState({
			currentUser: this.state.currentUser,
			...anotherStates,
		});
	}
	setMenuStatus(e) {
		e.preventDefault();
		this.setState({ hasMenu: !this.state.hasMenu });
	}

	render() {
		const {
			authenticated,
			center_loading,
			top_loading,
			hasMenu,
			currentUser,
		} = this.state;

		if (center_loading) {
			return (
				<img
					className={'imgLoading'}
					src={process.env.PUBLIC_URL + '/assets/images/loading.gif'}
					alt="loading"
				/>
			);
		}

		if (!authenticated) {
			return (
				<GuestRouter
					process={process}
					currentUser={currentUser}
					authenticated={authenticated}
					onRequestLoading={this.onRequestLoading}
					onLogout={this.onLogout}
					firebase={this.props.firebase}
				/>
			);
		} else {
			const auth = this.props.firebase.auth,
				user = auth.currentUser,
				{ emailVerified } = user,
				{ providerData = [{}] } = user;

			let providerId = false;
			if (providerData.length > 0) {
				providerId = providerData[0];
			}

			if (!emailVerified && providerId === 'password') {
				return (
					<EmailNotVerifiedRouter
						process={process}
						currentUser={currentUser}
						authenticated={authenticated}
						onRequestLoading={this.onRequestLoading}
						onLogout={this.onLogout}
						auth={auth}
					/>
				);
			}

			if (this.state.currentUser.terms === false && !user.isAnonymous) {
				Server.sendTermsData(this.state.currentUser.uid);
			}
		}

		return (
			<LoggedRouter
				process={process}
				currentUser={currentUser}
				authenticated={authenticated}
				onRequestLoading={this.onRequestLoading}
				onLogout={this.onLogout}
				firebase={this.props.firebase}
				setUserParams={this.setUserParams}
				top_loading={top_loading}
				hasMenu={hasMenu}
				setMenuStatus={this.setMenuStatus}
				helpers={this.state.helpers}
				trackEvent={this.trackEvent}
			/>
		);
	}
}

export default withFirebase(MyRouter);
